import { PrivateInterceptor } from "../../../Base/interceptors/PrivateInterceptor"
// import { PrivateInterceptorsPR } from "../../../Base/interceptors/PrivateinterceptorsPR";

// OBTENER ORGANIGRAMA

export const getOrganigrama = async () => {
    const result = await PrivateInterceptor(`Organigrama`, 'GET');
    return result;
}


// obtener imagenes de personas
export const getImagenes = async (personas) => {
    const result = await PrivateInterceptor(`Imagenes/Carnet`, 'POST', {personas});
    return result;
}